import { createCustomEnum } from "./customEnum";

const BoardingQaResultTypes = createCustomEnum({
	QaApproved: {
		value: 0,
		name: "qa_approved",
		displayName: "QA Approved",
	},
	QaRejected: {
		value: 1,
		name: "qa_rejected",
		displayName: "QA Rejected",
	},
});

export default BoardingQaResultTypes;

